import { initializeFirebase } from '../firebase';
import config from '../../app.config'

import { LOGIN_SUCCESS } from "../constants/general";

const firebase = (store) => (next) => (action) => {
    if (action.type === LOGIN_SUCCESS && !action.user.isAnonymous()) {
        initializeFirebase(config.FIREBASE_CREDENTIALS);
    }
    next(action);
};

export default firebase;



// WEBPACK FOOTER //
// ./src/middleware/firebase.js